// material-ui
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Stack, Popper, List, ListItemButton, Paper, ListItemText, Typography, Divider, ClickAwayListener } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Transitions from 'ui-component/extended/Transitions';
import MainCard from 'ui-component/cards/MainCard';
import { useMediaQuery } from '@mui/material';
import question from 'assets/images/auth/question.svg';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = () => {
  const navigate = useNavigate();
  const theme = useTheme();
  const siteInfo = useSelector((state) => state.siteInfo);
  const account = useSelector((state) => state.account);
  const [open, setOpen] = useState(null);

  const handleCloseMenu = () => {
    setOpen(null);
  };
  const onDoc = () => {
    navigate('/panel/text-doc');
  };
  const onGoHome = () => {
    navigate('/');
  };
  return (
    <>
      <Box
        sx={{
          width: 228,
          display: 'flex',
          [theme.breakpoints.down('md')]: {
            width: 'auto'
          }
        }}
      ></Box>

      <Box sx={{ flexGrow: 1 }} />
      <Box sx={{ flexGrow: 1 }} />
      <Stack spacing={1} direction="row" justifyContent="center" alignItems="center">
        <>
          <a onClick={onGoHome} style={{ textDecoration: 'none' }}>
            <Typography
              sx={{
                backgroundColor: 'transparent',
                color: theme.palette.primary.textSecondary,
                fontSize: '14px',
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: theme.palette.primary.textSecondary
                },
                mr: '20px'
              }}
            >
              返回首页
            </Typography>
          </a>

          <a onClick={onDoc} target="_blank" style={{ textDecoration: 'none' }}>
            <Typography
              sx={{
                backgroundColor: 'transparent',
                color: theme.palette.primary.textSecondary,
                fontSize: '14px',
                '&:hover': {
                  backgroundColor: 'transparent',
                  color: theme.palette.primary.textSecondary
                }
              }}
            >
              <img src={question} alt="question" style={{ verticalAlign: 'top', width: '18px', marginRight: '5px' }} />
              帮助中心
            </Typography>
          </a>
        </>
      </Stack>

      <Popper
        open={!!open}
        anchorEl={open}
        transition
        disablePortal
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 14]
              }
            }
          ]
        }}
        style={{ width: '100vw' }}
      >
        {({ TransitionProps }) => (
          <Transitions in={open} {...TransitionProps}>
            <ClickAwayListener onClickAway={handleCloseMenu}>
              <Paper style={{ width: '100%' }}>
                <MainCard border={false} elevation={16} content={false} boxShadow shadow={theme.shadows[16]}>
                  <List
                    component="nav"
                    sx={{
                      width: '100%',
                      maxWidth: '100%',
                      minWidth: '100%',
                      backgroundColor: theme.palette.background.paper,
                      '& .MuiListItemButton-root': {
                        mt: 0.5
                      }
                    }}
                    onClick={handleCloseMenu}
                  >
                    <ListItemButton component={Link} variant="text" to="/">
                      <ListItemText primary={<Typography variant="body2">首页</Typography>} />
                    </ListItemButton>
                    <Divider />
                    {account.user ? (
                      <ListItemButton component={Link} variant="contained" to="/panel/index" color="primary">
                        控制台
                      </ListItemButton>
                    ) : (
                      <ListItemButton component={Link} variant="contained" to="/login/index" color="primary">
                        登录
                      </ListItemButton>
                    )}
                  </List>
                </MainCard>
              </Paper>
            </ClickAwayListener>
          </Transitions>
        )}
      </Popper>
    </>
  );
};

export default Header;
